import React from "react";
import { Box } from "@mantine/core";
import { keyframes } from "@emotion/react";

// Define keyframes for the wave effect
const pulse = keyframes`
  0% {
    transform: scale(0.5);
    opacity: 0.5;
  }
    50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
`;

const AnimatedWaves = () => {
  const circles = Array.from({ length: 6 }).map((_, index) => (
    <Box
      key={index}
      sx={{
        width: "5px",
        height: "5px",
        borderRadius: "50%",
        backgroundColor: "red",
        position: "absolute",
        animation: `${pulse} 3s ${index * 0.6}s infinite`,
      }}
    />
  ));

  return (
    <Box
      sx={{
        position: "relative",
        width: "15px",
        height: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {circles}
    </Box>
  );
};

export default AnimatedWaves;
